import { format, parseISO, startOfMonth } from "date-fns";
import AuthService from "./index";

// Lê do localStorage o contexto que o usuário já escolheu no filtro do painel
// (chave 'filter_bi', gravada ao clicar Buscar): unidades selecionadas e o mês.
// O período é o mês selecionado truncado até hoje, pra bater com o dashboard.
// Se nada foi buscado ainda, devolve vazio — o backend resolve as unidades
// permitidas e o modelo escolhe a janela.
export function lerContextoFiltro() {
  try {
    const raw = localStorage.getItem("filter_bi");
    if (!raw) return { unidades: [], periodo: null };

    const f = JSON.parse(raw);
    const unidades = String(f.unidade || "")
      .split(",")
      .map((n) => Number(n))
      .filter(Number.isFinite);

    let periodo = null;
    if (f.today) {
      const hoje = format(new Date(), "yyyy-MM-dd");
      const inicio = format(startOfMonth(parseISO(f.today)), "yyyy-MM-dd");
      const fim = f.endDate && f.endDate > hoje ? hoje : f.endDate || hoje;
      periodo = { inicio, fim };
    }

    return { unidades, periodo };
  } catch (e) {
    console.error("lerContextoFiltro falhou:", e);
    return { unidades: [], periodo: null };
  }
}

// Envia uma mensagem ao /chat. `historico` é opaco (formato Gemini) e deve
// ser devolvido a cada turno pra manter o contexto da conversa.
export async function enviarMensagem({ mensagem, historico, unidades, periodo }) {
  const service = new AuthService();
  return service.post("/chat", {
    mensagem,
    historico: historico || [],
    unidade: unidades || [],
    periodoSelecionado: periodo || undefined,
  });
}

// Feedback 👍/👎 sobre uma resposta da Sisa. Chamado fire-and-forget no widget:
// falha de rede não incomoda o usuário.
export async function enviarFeedback({ respostaId, util, comentario }) {
  const service = new AuthService();
  return service.post("/chat/feedback", {
    respostaId,
    util,
    comentario: comentario || undefined,
  });
}
